import axios from 'axios';

// Create an axios instance with defaults
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
};

export const fetchThemes = async () => {
  const response = await api.get('/api/media/themes');
  return response.data;
};

export const uploadDrawing = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/api/media/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const generateVideo = async (payload) => {
  const response = await api.post('/api/media/generate', payload);
  return response.data;
};

export const fetchTokenPacks = async () => {
  const response = await api.get('/api/payments/packs');
  return response.data;
};

export const createCheckoutSession = async ({ packId, successUrl, cancelUrl, email }) => {
  const response = await api.post(
    '/api/payments/create_checkout',
    {
      pack_id: packId,
      success_url: successUrl,
      cancel_url: cancelUrl,
      customer_email: email,
    },
  );
  return response.data;
};

export const fetchGenerations = async () => {
  const response = await api.get('/api/media/generations');
  return response.data;
};

export const deleteGeneration = async (generationId) => {
  const response = await api.delete(`/api/media/generations/${generationId}`);
  return response.data;
};

export const getGenerationDownloadUrl = async (generationId) => {
  const response = await api.get(`/api/media/generations/${generationId}/download`);
  return response.data;
};

export const fetchGenerationStatus = async (jobId) => {
  const response = await api.get(`/api/media/generation/${jobId}`);
  return response.data;
};

export const createSupportTicket = async (payload) => {
  const response = await api.post('/api/support/tickets', payload);
  return response.data;
};

export const fetchMySupportTickets = async () => {
  const response = await api.get('/api/support/tickets/mine');
  return response.data;
};

export const fetchSupportTicketsAdmin = async (status) => {
  const params = status ? { status_filter: status } : undefined;
  const response = await api.get('/api/support/admin/tickets', { params });
  return response.data;
};

export const updateSupportTicketStatus = async (ticketId, status) => {
  const response = await api.patch(`/api/support/admin/tickets/${ticketId}`, {
    status,
  });
  return response.data;
};

export default api;
